module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/rbis-6e667c1b86f81c0649350ca31ae75808.svg";